import { DashboardCard } from "@/shared/ui/DashboardCard";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { ctaPerformance } from "../data";

const ctaKeys = ["getStarted", "watchDemo", "contactSales", "downloadPdf"] as const;

export function CTAPerformanceCard() {
  const { t } = useTranslation();

  return (
    <DashboardCard title={t.landing.ctaPerformance}>
      <div className="space-y-3">
        {ctaPerformance.map((cta, i) => (
          <div key={ctaKeys[i]} className="rounded-xl bg-card-muted px-4 py-3">
            <div className="flex items-center justify-between">
              <p className="text-sm font-medium text-foreground">{t.landing.ctas[ctaKeys[i]]}</p>
              <span className="text-sm font-bold text-primary">{cta.rate}</span>
            </div>
            <p className="mt-1 text-xs text-muted">
              {cta.clicks.toLocaleString()} {t.common.clicks}
            </p>
          </div>
        ))}
      </div>
    </DashboardCard>
  );
}
